import { useMutation } from "@apollo/client";
import {
  UPDATE_GENERATION_TEMPLATE,
  GET_GENERATION_TEMPLATES,
  GET_GENERATION_TEMPLATE_BY_ID,
} from "../gql";
import type {
  UpdateGenerationTemplateInput,
  UpdateGenerationTemplatePayload,
} from "@casey/db-types";

interface UseUpdateGenerationTemplateResult {
  updateTemplate: (
    input: UpdateGenerationTemplateInput,
  ) => Promise<UpdateGenerationTemplatePayload>;
  loading: boolean;
  error: Error | null;
}

export function useUpdateGenerationTemplate(
  organizationId: string,
): UseUpdateGenerationTemplateResult {
  const [mutate, { loading, error }] = useMutation<{
    updateGenerationTemplate: UpdateGenerationTemplatePayload;
  }>(UPDATE_GENERATION_TEMPLATE, {
    refetchQueries: [
      {
        query: GET_GENERATION_TEMPLATES,
        variables: { organizationId },
      },
    ],
  });

  const updateTemplate = async (
    input: UpdateGenerationTemplateInput,
  ): Promise<UpdateGenerationTemplatePayload> => {
    const result = await mutate({
      variables: { input },
      refetchQueries: [
        {
          query: GET_GENERATION_TEMPLATE_BY_ID,
          variables: { id: input.id },
        },
      ],
    });

    if (!result.data?.updateGenerationTemplate) {
      throw new Error("Failed to update template");
    }

    return result.data.updateGenerationTemplate;
  };

  return {
    updateTemplate,
    loading,
    error: error || null,
  };
}
